// eslint-disable-next-line no-restricted-imports
import { useLocale as useNextIntlLocale } from 'next-intl';
import { ELanguage } from '@portals/help-center-core';
import { getRouteLocale } from '@/i18n/get-route-locale';

export const useLocale = (): ELanguage => {
  return getRouteLocale(useNextIntlLocale()) as ELanguage;
};
